import { render, staticRenderFns } from "./AddNewDocument.vue?vue&type=template&id=3a695733&scoped=true&lang=pug&"
import script from "./AddNewDocument.vue?vue&type=script&lang=js&"
export * from "./AddNewDocument.vue?vue&type=script&lang=js&"
import style0 from "./AddNewDocument.vue?vue&type=style&index=0&id=3a695733&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a695733",
  null
  
)

/* custom blocks */
import block0 from "./AddNewDocument.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VImg,VSpacer})
